<template>
    <div class="remarketing-section">
        <div class="remarketing-content">
            <h2 class="remarketing-title fuente-posm">
                La clave está en el remarketing
            </h2>
            <p class="remarketing-text fuente-nova">
                Ahora es tu momento de activar la publicidad más rentable: la basada en tus propios clientes.
                <br><br>
                Recupera clientes que no han venido en mucho tiempo enviándoles mensajes de WhatsApp directamente.
                <br><br>
                Descarga una base de datos para uso en meta ads y google ads
            </p>
        </div>
        <div class="remarketing-image">
            <img :src="a54" alt="Remarketing">
        </div>
    </div>
</template>

<script>
export default {
    name: 'RemarketingNew',
    data() {
        return {
            a54: require('@/assets/images/a54.webp')
        }
    }
}
</script>

<style lang="css" scoped>
.remarketing-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    gap: 40px;
}

.remarketing-image {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    order: 1;
}

.remarketing-image img {
    width: 280px;
    height: auto;
}

.remarketing-content {
    flex: 1;
    max-width: 700px;
    order: 2;
}

.remarketing-title {
    color: var(--color-2);
    font-size: 68px;
    line-height: 1.1;
    margin: 0 0 20px 0;
}

.remarketing-text {
    color: var(--color-3);
    font-size: 29px;
    line-height: 1.3;
    margin: 0;
    padding-left: 10px;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .remarketing-title {
        font-size: 60px;
    }

    .remarketing-text {
        font-size: 27px;
    }

    .remarketing-image img {
        width: 220px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .remarketing-section {
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;
        padding: 100px 20px 40px 20px;
        gap: 20px;
    }

    .remarketing-content {
        order: 1;
        max-width: 100%;
        flex: none;
    }

    .remarketing-image {
        order: 2;
        width: 100%;
        flex: 1;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 20px;
    }

    .remarketing-image img {
        width: 80%;
        max-width: 320px;
    }

    .remarketing-title {
        font-size: 24px;
        line-height: 1.2;
        margin: 0 0 10px 0;
    }

    .remarketing-text {
        font-size: 16px;
        padding-left: 10px;
        margin: 0;
    }
}
</style>
